import axios from "axios";
import { APIRequestURI } from "../../utils/api_request_uri";
import {
  GET_LEADERBOARD_FAIL,
  GET_LEADERBOARD_REQUEST,
  GET_LEADERBOARD_SUCCESS,
} from "../../constants/Leaderboard/leaderboardConstants";

export const getLeaderboardDataAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_LEADERBOARD_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo?.token}`,
      },
    };

    const URI = new APIRequestURI().getBaseURI();
    const { data } = await axios.get(`${URI}/api/leaderboard/`, config);

    dispatch({
      type: GET_LEADERBOARD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_LEADERBOARD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
